import { I18N } from '../actionTypes';

export const changeLocale = (locale) => {
  localStorage.setItem("locale", locale);
  return {
    type    : I18N.CHANGE_LOCALE,
    locale  : locale
  };
}
